import React from 'react'
import { Create } from 'react-admin'
import Form from './form'

const HourlyTicketsCreate = props => {
  return (
    <Create {...props} >
      <Form />
    </Create>
  )
}

export default HourlyTicketsCreate
